import {config} from "@/config";

export default {
    namespaced: true,
    state: {
        brands: [
        ],
        currentSort:'saleId',
        currentSortDir:'asc',
        pageSize:10,
        currentPage:1,
        countRow: 0,
        siteFilter: false,
        groupFilter: false,
        nameFilter: false,

        idFilter: false,
        ratingFilter: false,
        efficiencyFilter: false,
        ruFrequencyFilter: false,
        wwFrequencyFilter: false,
        goodsNumberFilter: false,
        pureArticlesFilter: false,
        // brandTasksFilter: false,
        brandTagFilter: [],
        lastDateFilter: false,

        idToFilter: false,
        ratingToFilter: false,
        efficiencyToFilter: false,
        ruFrequencyToFilter: false,
        wwFrequencyToFilter: false,
        goodsNumberToFilter: false,
        pureArticlesToFilter: false,
        lastDateToFilter: false,

        exportMinUrl: config.apiUrl + '/brand/export/min',
        exportMaxUrl: config.apiUrl + '/brand/export/max',
        exportUrlFilter: '',
        tagList: [],
        isSendAlready: false,

        fieldFullList: [
            {
                key: 'saleId',
                label: 'id CRM',
                sortable: true
            },
            {
                key: 'name',
                label: 'Название',
                sortable: true
            },
            {
                key: 'group',
                label: 'Группа',
                sortable: true
            },
            {
                key: 'rating',
                label: 'Рейтинг',
                sortable: true
            },
            {
                key: 'efficiency',
                label: 'Эфф',
                sortable: true
            },
            {
                key: 'ruFrequency',
                label: 'Частотность RU',
                sortable: true
            },
            {
                key: 'wwFrequency',
                label: 'Частотность WW',
                sortable: true
            },
            {
                key: 'goodsNumber',
                label: 'Число товаров',
                sortable: true
            },
            {
                key: 'pureArticles',
                label: 'Число артикулов',
                sortable: true
            },
            {
                key: 'tags',
                label: 'Тег',
                sortable: true
            },
            {
                key: 'lastDate',
                label: 'Дата оптим.',
                sortable: true
            },
            {
                key: 'site',
                label: 'Оф. сайт',
                sortable: true
            },
            {
                key: 'groupOfBrands',
                label: 'Группа брендов',
                sortable: true
            },
            {
                key: 'country',
                label: 'Страна брендов',
                sortable: true
            },
            {
                key: 'dealerStatus',
                label: 'Наш стат. дил-ва',
                sortable: true
            },
            {
                key: 'onOurSite',
                label: 'На нашем сайте',
                sortable: true
            },

            {
                key: 'categoryCount',
                label: 'Кол. категорий',
                sortable: true
            },
            {
                key: 'ruSearchQueriesQuery',
                label: 'Запросы RU',
                sortable: false
            },
            {
                key: 'wwSearchQueriesQuery',
                label: 'Запросы WW',
                sortable: false
            },
            {
                key: 'seoZero',
                label: 'число товаров SEO=0',
                sortable: false
            },
            {
                key: 'shop',
                label: 'число товаров с флагом онлайн-шоп = 1',
                sortable: false
            },
            {
                key: 'price',
                label: 'число товаров с ценой закупки',
                sortable: false
            },
            {
                key: 'photo',
                label: 'число товаров с фото',
                sortable: false
            },
            {
                key: 'category',
                label: 'число товаров с категориями',
                sortable: false
            }
        ],
        activeField: [
            {
                key: 'saleId',
                label: 'id CRM',
                sortable: true
            },
            {
                key: 'name',
                label: 'Название',
                sortable: true
            },
            {
                key: 'group',
                label: 'Группа',
                sortable: true
            },
            {
                key: 'rating',
                label: 'Рейтинг',
                sortable: true
            },
            {
                key: 'efficiency',
                label: 'Эфф',
                sortable: true
            },
            {
                key: 'ruFrequency',
                label: 'Частотность RU',
                sortable: true
            },
            {
                key: 'wwFrequency',
                label: 'Частотность WW',
                sortable: true
            },
            {
                key: 'goodsNumber',
                label: 'Число товаров',
                sortable: true
            },
            {
                key: 'tags',
                label: 'Тег',
                sortable: true
            },
            {
                key: 'lastDate',
                label: 'Дата оптим.',
                sortable: true
            },
            {
                key: 'site',
                label: 'На сайте',
                sortable: true
            },
        ],
        selectedField: {
            0: 'saleId',
            1: 'name',
            2: 'group',
            3: 'rating',
            4: 'efficiency',
            5: 'ruFrequency',
            6: 'wwFrequency',
            7: 'goodsNumber',
            8: 'pureArticles',
            9: 'tags',
            10: 'lastDate',
            11: 'site',
            12: 'seoZero',
            13: 'shop',
            14: 'price',
            15: 'photo',
            16: 'category',
        },
        filter: {}
    },
    getters: {
        FILTER: state => {
            return state.filter;
        },
        SELECTED_FIELD: state => {
            return state.selectedField;
        },
        FIELD_FULL_LIST: state => {
            return state.fieldFullList;
        },
        ACTIVE_FIELD: state => {
            return state.activeField;
        },
        IS_SEND_ALREADY: state => {
            return state.isSendAlready;
        },
        TAG_LIST: state => {
            return state.tagList;
        },
        EXPORT_MIN_URL: state => {
            return state.exportMinUrl;
        },
        EXPORT_MAX_URL: state => {
            return state.exportMaxUrl;
        },
        EXPORT_URL_FILTER: state => {
            return state.exportUrlFilter;
        },

        BRAND_LIST: state => {
            return state.brands;
        },
        CURRENT_SORT: state => {
            return state.currentSort;
        },
        COUNT_ROW: state => {
            return state.countRow;
        },
        ID_FILTER: state => {
            return state.idFilter;
        },
        NAME_FILTER: state => {
            return state.nameFilter;
        },
        CURRENT_SORT_DIR: state => {
            return state.currentSortDir;
        },
        PAGE_SIZE: state => {
            return state.pageSize;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        SITE_FILTER: state => {
            return state.siteFilter;
        },
        GROUP_FILTER: state => {
            return state.groupFilter;
        },

        AMOUNT_PAGE: (state, getters) => {
            return Math.ceil(getters.COUNT_ROW/state.pageSize);
        }
    },
    mutations: {
        FILTER: (state, payload) => {
            return state.filter[payload.name] = payload.value;
        },
        SELECTED_FIELD: (state, payload) => {
            return state.selectedField = payload;
        },
        FIELD_FULL_LIST: (state, payload) => {
            return state.fieldFullList = payload;
        },
        ACTIVE_FIELD: (state, payload) => {
            return state.activeField = payload;
        },
        IS_SEND_ALREADY: (state, payload) => {
            return state.isSendAlready = payload;
        },
        TAG_LIST: (state, payload) => {
            return state.tagList = payload;
        },
        SET_EXPORT_URL_FILTER: (state, payload) => {
            return state.exportUrlFilter = payload;
        },

        SET_COUNT_ROW: (state, payload) => {
            return state.countRow = payload;
        },
        SET_BRANDS: (state, payload) => {
            return state.brands = payload;
        },
        CURRENT_SORT: (state, payload) => {
            return state.currentSort = payload;
        },
        CURRENT_SORT_DIR: (state, payload) => {
            return state.currentSortDir = payload;
        },
        PAGE_SIZE: (state, payload) => {
            return state.pageSize = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        CURRENT_PAGE_INCREMENT: (state) => {
            return state.currentPage++;
        },
        CURRENT_PAGE_DECREMENT: (state) => {
            return state.currentPage--;
        },
        SITE_FILTER: (state, payload) => {
            return state.siteFilter = payload;
        },
        SAVE_CHANGE: (state, payload) => {
            state.brands.forEach((row) => {
                if (payload.id == row.id) {
                    row.name = payload.name;
                    row.description = payload.description;
                    row.group = payload.group;
                    row.site = payload.site;
                }
            });
        }
    },
    actions: {
        createParamsUrl:  (params) => {
            let urlParams = [];
            for (let prop in params) {
                if (params[prop] !== false && params[prop] !== '' && params[prop] !== "[]") {
                    urlParams.push(prop +'='+ encodeURIComponent(params[prop]));
                }
            }
            return urlParams.join('&');
        },
        GET_ALL: async ({commit, getters, dispatch}, payload) => {
            let paginationParams = {
                'page': getters.CURRENT_PAGE,
                'pageSize': getters.PAGE_SIZE >= 1 ? getters.PAGE_SIZE : 1,
            };
            let params = {
                'sort': getters.CURRENT_SORT,
                'sortDir': getters.CURRENT_SORT_DIR,
            };
            let filters = {
                'name': getters.NAME_FILTER,
                'group': getters.GROUP_FILTER,
                // 'brandTasks': getters.BRAND_TASKS_FILTER,
                'site': getters.SITE_FILTER,
            };
            for (let key in filters) {
                if (filters[key].length > 0) {
                    params[key] = filters[key];
                }
            }

            for (let key in getters.FILTER) {
                if (getters.FILTER[key].length > 1) {
                    params[key] = getters.FILTER[key];
                }
            }

            let createParamsUrl = function (params) {
                let urlParams = [];
                for (let prop in params) {
                    if (params[prop] !== false && params[prop] !== '' && params[prop] !== "[]") {
                        urlParams.push(prop +'='+ encodeURIComponent(params[prop]));
                    }
                }
                return '?'+ urlParams.join('&');
            }

            let urlExportParams = createParamsUrl(params);
            commit('SET_EXPORT_URL_FILTER', urlExportParams);

            for (let key in paginationParams) {
                params[key] = paginationParams[key];
            }
            let urlParams = createParamsUrl(params);

            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand' + urlParams,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SET_BRANDS', responseData.data);
                    commit('SET_COUNT_ROW', responseData.count);
                    dispatch('FINANCE_PREPARE');
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },

        DO_EXPORT: async ({getters, rootGetters, actions}, payload) => {
            let url = 'min';
            let urlField = ''
            if (payload.type == 'min') {
                urlField = actions.createParamsUrl(payload.th.selectedField)
                url = getters.EXPORT_MIN_URL;
            } else {
                url = getters.EXPORT_MAX_URL;
            }

            await rootGetters.getHttpClient.get(url + getters.EXPORT_URL_FILTER +'&'+ urlField);// todo - show content
        },
        GET_TAGS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-tag-distinct',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('TAG_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        FILTER_CLEAN: function ({state}) {
            state.filter = {};
        },
        FINANCE_PREPARE: function ({state}) {
            let fields = [
                {
                    field: 'MPR',
                    key: 'MPR',
                    label: 'MPR'
                },
                {
                    field: 'applications',
                    key: 'Applications',
                    label: 'Заявки'
                },
                {
                    field: 'averageCheck',
                    key: 'AverageCheck',
                    label: 'Ср. Чек'
                },
                {
                    field: 'conversion',
                    key: 'Conversion',
                    label: 'Конв.'
                },
                {
                    field: 'demandForecast',
                    key: 'DemandForecast',
                    label: 'Пр. Спрос'
                },
                {
                    field: 'finEfficiency',
                    key: 'FinEfficiency',
                    label: 'Эфф.'
                },
            ];
            let periods = {1:'1', 2:'3', 3:'6', 4:'12', 5:'8'};
            let types = ['ru', 'ww'];

            for (let key3 in types) {
                for (let key1 in fields) {
                    for (let key2 in periods) {
                        let keyName = types[key3] + fields[key1].key + '_' + periods[key2] + '_Fin';
                        for (let key in state.brands) {
                            let finName = types[key3] == 'ru' ? 'financeRu' : 'financeWw';
                            if (
                                state.brands[key][finName].length === undefined
                                && state.brands[key][finName][key2] !== undefined
                            ) {
                                state.brands[key][keyName] = state.brands[key][finName][key2][fields[key1].field];
                            }
                        }

                        state.fieldFullList.push({
                            key: keyName,
                            label: fields[key1].label + ' (' + (periods[key2] == 8 ? '∞' : periods[key2])  + ') ' + types[key3],
                            sortable: false
                        });
                        // DemandForecast only for one month
                        if (fields[key1].key == 'DemandForecast') {
                            break;
                        }
                    }
                }
            }
        }
    }
}